<div class="row bg_bone">
  <div class="col-12 col-lg-7 p-5" [style]="{'height':(!isMobile) ? 'auto' : '67vh'}">
    <div class="row" [style]="{'margin-top':(!isMobile) ? '20vh' : '10vh'}">
      <div class="col-12 col-lg-8 offset-lg-2">
        <label for="2fa_confirm" class="mb-2">Please touch your security key to continue.</label>
        <input id="2fa_confirm" class="form-control" type="text" placeholder="Security Key Code" autocomplete="new-text" />
        <div class="mt-2">
          <button class="btn btn-sm btn-dark p-3 br-10" (click)="confirmCode()" style="width:100%">
            CONFIRM<i class="fas fa-fw fa-chevron-right ms-2"></i>
          </button>
          <div class="my-2">
            <button class="btn btn-sm btn-outline-dark me-2" (click)="backToChooser()">
              <i class="fas fa-fw fa-chevron-left me-2"></i>Choose Another Method
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="col-12 col-lg-5 px-0" [class]="(!isMobile) ? 'login_pic1' : 'bg_black'"
       [style]="{'height':(!isMobile) ? '100vh' : '33vh'}">
    <div class="p-4 c_white mobile_msg" *ngIf="(isMobile)">
      WelaraOS is not currently supported on mobile devices. Please
      visit the site on a laptop or desktop computer to log in and continue.
    </div>
  </div>
</div>









